import { createRendererWithDriver } from '../test-utils/utils/react';

export class PageHeaderPrivateDriver {
  constructor({ element, eventTrigger }) {
    this.element = element;
    this.eventTrigger = eventTrigger;
  }

  static fromJsxElement(jsxElement) {
    const driverFactory = ({ element, eventTrigger }) =>
      new PageHeaderPrivateDriver({ element, eventTrigger });
    const { driver } = createRendererWithDriver(driverFactory)(jsxElement);
    return driver;
  }

  byDataHook(dataHook) {
    return this.element.querySelector(`[data-hook="${dataHook}"]`);
  }

  existsByDataHook = dataHook => !!this.byDataHook(dataHook);

  propExists(dataHook, prop) {
    return !!this.byDataHook(dataHook).getAttribute(prop);
  }
}
